import React, { Suspense, lazy } from "react";
import { useLanguage, useT } from "@/lib/LanguageContext";
import { fmtDayMonth, fmtMonthYear } from "../format";
import CrmCard from "../ui/CrmCard";
import { CHART_COLORS } from "../theme/states";
import ChartLegend from "../ui/charts/ChartLegend";
import { CRM } from "../../../constants/testIds/crm";

const CrmBarChart = lazy(() => import("../ui/charts/CrmBarChart"));

/** "Sessions split · online vs offline" per week or month (spec). */
export default function SessionsSplitChart({ data }) {
  const t = useT("crm");
  const { lang } = useLanguage();
  const monthly = data.period?.bucket === "month";
  const formatX = (v) => (monthly ? fmtMonthYear(v, lang) : fmtDayMonth(v, lang));
  const series = [
    { key: "online", label: t("perf.online"), color: CHART_COLORS.ink, dot: "bg-eh-ink" },
    { key: "offline", label: t("perf.offline"), color: CHART_COLORS.sage, dot: "bg-eh-sage-deep" },
  ];
  return (
    <CrmCard data-testid={CRM.perfSplit}>
      <h3 className="font-display text-xl text-eh-ink">{t("perf.splitTitle")}</h3>
      <Suspense fallback={<div className="h-[180px]" aria-busy="true" />}>
        <CrmBarChart data={data.sessions_split || []} series={series} formatX={formatX} label={t("perf.splitTitle")} />
      </Suspense>
      <ChartLegend items={series.map((s) => ({ key: s.key, label: s.label, colorClass: s.dot }))} />
    </CrmCard>
  );
}
